class HeroMediaSlider {
  constructor(section) {
    this.section = section;
    this.hero = section.querySelector('.hero-media');
    this.track = section.querySelector('[data-hero-track]');
    this.slides = Array.from(section.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(section.querySelectorAll('[data-hero-dot]'));
    this.prevButton = section.querySelector('[data-hero-prev]');
    this.nextButton = section.querySelector('[data-hero-next]');
    this.toggleButton = section.querySelector('[data-hero-toggle]');

    this.autoplayEnabled = section.dataset.autoplay === 'true';
    this.autoplaySpeed = Number(section.dataset.autoplaySpeed || 5000);
    this.currentIndex = 0;
    this.interval = null;
    this.userPaused = false;
    this.touchStartX = 0;
    this.touchEndX = 0;

    if (!this.track || this.slides.length <= 1) return;

    this.init();
  }

  init() {
    this.update(false);
    this.bindEvents();

    if (this.autoplayEnabled) {
      this.startAutoplay();
    } else {
      this.hero.classList.add('is-paused');
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-pressed', 'true');
        this.toggleButton.setAttribute('aria-label', 'Retomar autoplay');
      }
    }
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.prev();
        this.restartAutoplay();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index || 0);
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => {
        if (this.userPaused) {
          this.userPaused = false;
          this.hero.classList.remove('is-paused');
          this.toggleButton.setAttribute('aria-pressed', 'false');
          this.toggleButton.setAttribute('aria-label', 'Pausar autoplay');
          this.startAutoplay();
        } else {
          this.userPaused = true;
          this.pauseAutoplay();
          this.hero.classList.add('is-paused');
          this.toggleButton.setAttribute('aria-pressed', 'true');
          this.toggleButton.setAttribute('aria-label', 'Retomar autoplay');
        }
      });
    }

    this.track.addEventListener(
      'touchstart',
      (event) => {
        this.touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    this.track.addEventListener(
      'touchend',
      (event) => {
        this.touchEndX = event.changedTouches[0].clientX;
        this.handleSwipe();
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoplay();
      } else if (this.autoplayEnabled && !this.userPaused) {
        this.startAutoplay();
      }
    });

    window.addEventListener('resize', () => {
      this.update(false);
    });
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) < 50) return;

    if (diff > 0) {
      this.next();
    } else {
      this.prev();
    }

    this.restartAutoplay();
  }

  goTo(index) {
    if (index < 0) index = this.slides.length - 1;
    if (index > this.slides.length - 1) index = 0;

    this.currentIndex = index;
    this.update(true);
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  prev() {
    this.goTo(this.currentIndex - 1);
  }

  update(animateBars = true) {
    this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

    this.dots.forEach((dot, index) => {
      dot.classList.remove('is-active', 'is-animating');
      dot.removeAttribute('aria-current');
      dot.style.removeProperty('--hero-progress-duration');

      if (index === this.currentIndex) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');

        if (animateBars && this.autoplayEnabled && !this.userPaused) {
          dot.style.setProperty('--hero-progress-duration', `${this.autoplaySpeed}ms`);
          void dot.offsetWidth;
          dot.classList.add('is-animating');
        }
      }
    });
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.userPaused) return;

    this.clearAutoplay();
    this.hero.classList.remove('is-paused');
    this.update(true);

    this.interval = window.setInterval(() => {
      this.next();
    }, this.autoplaySpeed);
  }

  pauseAutoplay() {
    this.clearAutoplay();

    this.dots.forEach((dot) => {
      dot.classList.remove('is-animating');
    });
  }

  restartAutoplay() {
    if (!this.autoplayEnabled || this.userPaused) {
      this.update(false);
      return;
    }

    this.startAutoplay();
  }

  clearAutoplay() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }
}

function initHeroMediaSections() {
  const sections = document.querySelectorAll('[data-hero-media]');

  sections.forEach((section) => {
    if (section.dataset.heroMediaInitialized === 'true') return;
    section.dataset.heroMediaInitialized = 'true';
    new HeroMediaSlider(section);
  });
}

document.addEventListener('DOMContentLoaded', initHeroMediaSections);
document.addEventListener('shopify:section:load', initHeroMediaSections);